import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/react";

var container = function container(theme) {
  return {
    border: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.white,
    marginBottom: '1.5em'
  };
};

var headerRow = function headerRow(theme) {
  return {
    padding: '1.2em 2em',
    backgroundColor: theme.gray50,
    borderBottom: "1px solid ".concat(theme.gray100),
    fontSize: '1.4rem',
    fontWeight: 600,
    color: theme.gray700,
    textTransform: 'uppercase',
    letterSpacing: '0.04em'
  };
};

var grid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  '@media (max-width: 1200px)': {
    gridTemplateColumns: 'repeat(3, 1fr)'
  },
  '@media (max-width: 700px)': {
    gridTemplateColumns: '1fr'
  }
};

var section = function section(theme) {
  return {
    padding: '1.4em 2em',
    borderRight: "1px solid ".concat(theme.gray100),
    '&:last-of-type': {
      borderRight: 'none'
    },
    '@media (max-width: 1200px)': {
      borderBottom: "1px solid ".concat(theme.gray100)
    },
    '@media (max-width: 700px)': {
      borderRight: 'none'
    }
  };
};

var sectionTitle = function sectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5em',
    marginBottom: '1em',
    '& i': {
      fontSize: '1.5rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.2rem',
      fontWeight: 600,
      color: theme.gray400,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var row = function row(theme) {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.4em 0',
    '& .label': {
      fontSize: '1.2rem',
      color: theme.gray400
    },
    '& .value': {
      fontSize: '1.2rem',
      fontWeight: 600,
      color: theme.gray700
    }
  };
};

var totalLine = function totalLine(theme) {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5em 0',
    marginTop: '0.4em',
    borderTop: "1px solid ".concat(theme.gray100),
    '& .label': {
      fontSize: '1.2rem',
      fontWeight: 600,
      color: theme.gray600
    },
    '& .value': {
      fontSize: '1.3rem',
      fontWeight: 700,
      color: theme.primary
    }
  };
};

var fmt = function fmt(val, cur) {
  return "".concat(val !== null && val !== void 0 ? val : '--', " ").concat(cur);
};

var weeks = [{
  key: '1_week',
  label: 'До 1 седм.'
}, {
  key: '2_week',
  label: 'До 2 седм.'
}, {
  key: '3_week',
  label: 'До 3 седм.'
}, {
  key: '4_week',
  label: 'До 4 седм.'
}, {
  key: '5+_week',
  label: '5+ седм.'
}];

var ReceivablesByMaturityValuesList = function ReceivablesByMaturityValuesList(_ref) {
  var data = _ref.data,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? '' : _ref$currency;
  return ___EmotionJSX("div", {
    css: container
  }, ___EmotionJSX("div", {
    css: headerRow
  }, "\u0412\u0437\u0435\u043C\u0430\u043D\u0438\u044F \u043F\u043E \u043F\u0430\u0434\u0435\u0436"), ___EmotionJSX("div", {
    css: grid
  }, weeks.map(function (_ref2) {
    var key = _ref2.key,
        label = _ref2.label;
    return ___EmotionJSX("div", {
      css: section,
      key: key
    }, ___EmotionJSX("div", {
      css: sectionTitle
    }, ___EmotionJSX("i", {
      className: "las la-calendar-week"
    }), ___EmotionJSX("span", null, label)), ___EmotionJSX("div", {
      css: row
    }, ___EmotionJSX("span", {
      className: "label"
    }, "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0438"), ___EmotionJSX("span", {
      className: "value"
    }, fmt(data === null || data === void 0 ? void 0 : data["total_late_principals_".concat(key)], currency))), ___EmotionJSX("div", {
      css: row
    }, ___EmotionJSX("span", {
      className: "label"
    }, "\u041B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
      className: "value"
    }, fmt(data === null || data === void 0 ? void 0 : data["total_late_interests_".concat(key)], currency))), ___EmotionJSX("div", {
      css: row
    }, ___EmotionJSX("span", {
      className: "label"
    }, "\u0422\u0430\u043A\u0441\u0438"), ___EmotionJSX("span", {
      className: "value"
    }, fmt(data === null || data === void 0 ? void 0 : data["total_late_fees_".concat(key)], currency))), ___EmotionJSX("div", {
      css: totalLine
    }, ___EmotionJSX("span", {
      className: "label"
    }, "\u041E\u0431\u0449\u043E"), ___EmotionJSX("span", {
      className: "value"
    }, fmt(data === null || data === void 0 ? void 0 : data["total_late_".concat(key)], currency))));
  })));
};

ReceivablesByMaturityValuesList.propTypes = {
  data: PropTypes.object,
  currency: PropTypes.string
};
export default ReceivablesByMaturityValuesList;